import * as React from "react";
import { singleton } from "logic/singleton";
import { DAYS } from "components/common/Graph/types";
const defaultContext = {
  graphDays: DAYS[0],
  setGraphDays: () => void 0
};
const GraphDaysContext = React.createContext(defaultContext);
export default singleton("contexts.GraphDays", () => GraphDaysContext);
